const musicLibraryItems = [
  {
    id: 0,
    title: "Echo Beach",
    color: "musicLibraryColor2",
    playlistURL: "echo-beach/pl.u-gxbllJ0Tx9BlaL?l",
  },
  {
    id: 1,
    title: "Acceptable Country",
    color: "musicLibraryColor1",
    playlistURL: "accepteble-country/pl.u-WabZZy3cRa4NAj",
  },
  {
    id: 2,
    title: "Unplugged Pop",
    color: "musicLibraryColor4",
    playlistURL: "unplugged-pop/pl.u-gxblkXxFx9BlaL?l",
  },
  {
    id: 3,
    title: "Open Adventure",
    color: "musicLibraryColor3",
    playlistURL: "open-adventure/pl.u-oZyllR9IqW5aBM?l",
  },
];

export default musicLibraryItems;
